const Constants = {

    API_KEY:"q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
    TYPE_NOTICIA: "NOTICIA",
    TYPE_EVENTO: "EVENTO",
    TYPE_PROJETO: "PROJETO"

}

export default Constants;
